export const IDENTITY_CLIENT_GROUP = "clientes"
export const IDENTITY_ADMIN_GROUP = "identity"